import { makeStyles } from '@mui/styles';
import { BREAKPOINTS } from '@styles/breakpoints';
import { COLORS } from '@styles/colors';

export const useStyles = makeStyles({
  navText: {
    marginLeft: 16,
    fontSize: '14px',
    lineHeight: '140%',
    fontWeight: '400',

    [BREAKPOINTS.TABLET]: {
      display: 'none',
    },
    [BREAKPOINTS.MOBILE]: {
      display: 'block',
    },
  },
  shown: {
    display: 'block',
  },
  searchButton: {
    display: 'none',

    [BREAKPOINTS.MOBILE]: {
      display: 'block',
    },
  },
  navItem: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    textDecoration: 'none',
    minHeight: 48,
    paddingLeft: 16,
    borderRadius: 6,
    marginTop: 4,
    cursor: 'pointer',
    color: COLORS.TEXT.PRIMARY,
    backgroundColor: COLORS.WHITE,
    transition: 'all 0.2s linear',

    '& svg': {
      color: COLORS.TEXT.SECONDARY,
      transition: 'all 0.2s linear',
    },

    '&:hover': {
      backgroundColor: COLORS.HIGHLIGHTS.NEUTRAL,

      '& svg': {
        color: COLORS.BRAND.PRIMARY,
        transform: 'scale(1.1)',
      },
    },

    [BREAKPOINTS.TABLET]: {
      justifyContent: 'center',
      paddingLeft: 0,
    },
    [BREAKPOINTS.MOBILE]: {
      justifyContent: 'flex-start',
      paddingLeft: 24,
      marginRight: 12,
      marginLeft: 12,
      width: 'auto',
    },
  },
});
